/**
 * KAN-883: выбор периода. Один компонент для таблицы и доски CRM, "Лиды по дням"
 * и "Появился" на странице теплоты. Корень - role group с aria-label и
 * data-testid; состояние у вызывающего (адрес).
 * KAN-906: compact - высота 32px (компактная строка фильтров таблицы CRM).
 * KAN-963 (решение владельца): ряда быстрых кнопок в панели больше нет. Одна кнопка
 * календаря с подписью периода ("29 октября", "7 дней", "Всё время"), быстрые
 * периоды из choices сверху её окна, ниже календарь (CrmRangePicker).
 */
import { CrmRangePicker } from '@/components/crm/CrmRangePicker';
import type { CrmRange } from '@/lib/crmTable';
import type { PeriodChoice, PeriodPreset } from '@/lib/periodPresets';

interface CrmPeriodControlProps {
  label: string;
  choices: readonly PeriodChoice[];
  /** null - "Всё время" (только если в choices есть 'all'). */
  range: CrmRange | null;
  onChange: (range: CrmRange) => void;
  onAllTime?: () => void;
  /** KAN-910: быстрый пункт именем; без него пункт уходит в onChange датами. */
  onPreset?: (preset: PeriodPreset) => void;
  testId: string;
  /** Подпись слева видна (иначе только для чтения с экрана). */
  showLabel?: boolean;
  /** KAN-906: компактная высота (h-8) кнопки календаря. */
  compact?: boolean;
}

export function CrmPeriodControl({
  label,
  choices,
  range,
  onChange,
  onAllTime,
  onPreset,
  testId,
  showLabel = false,
  compact = false,
}: CrmPeriodControlProps): JSX.Element {
  const hasAllTime = choices.includes('all') && !!onAllTime;
  return (
    <div role="group" aria-label={label} data-testid={testId} className="flex min-w-0 shrink-0 items-center gap-2">
      {showLabel && <span className="hidden text-xs font-medium text-gray-500 lg:inline">{label}</span>}
      <CrmRangePicker
        range={range}
        onChange={onChange}
        onAllTime={hasAllTime ? onAllTime : undefined}
        onPreset={onPreset}
        choices={choices}
        compact={compact}
      />
    </div>
  );
}
